module.exports = __webpack_public_path__ + "img/img_32389_0_473.f90b3960.png";